<template>
  <div class="message-item" @click="showMessage = !showMessage">
    <b-row>
      <b-col cols="12" md="auto" class="message-item-icon">
        <template v-if="type==='received'">
          <template v-if="message.sender.type==='user'">
            <avatar :src="message.sender.photo" size="2.5rem" />
          </template>
          <template v-else>
            <avatar size="2.5rem" />
          </template>
        </template>
        <template v-else-if="type==='sent'">
          <template v-if="message.receivers.length < 3">
            <avatar
              v-for="receiver in message.receivers"
              :key="receiver.id"
              :src="receiver.photo"
              size="2.5rem"
            />
          </template>
          <template v-else>
            <avatar variant="team" size="2.5rem" />
          </template>
        </template>
      </b-col>
      <b-col class="m-3 m-md-0">
        <b-row>
          <b-col>
            <div class="message-item-profile">
              <template v-if="type==='received'">
                {{userName(message.sender)}}
              </template>
              <template v-else-if="type==='sent'">
                <span v-for="receiver in message.receivers" :key="receiver.id" class="mr-3">
                  <template v-if="receiver.type==='user'">
                    {{userName(receiver)}}
                  </template>
                </span>
              </template>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md>
            <div :class="['message-item-preview my-2 my-md-0', { 'font-weight-bold': !message.seenAt }]">
              {{preview}}
            </div>
          </b-col>
          <b-col cols="6" md="2">
            <message-type :type="message.category" />
          </b-col>
          <b-col cols="6" md="3">
            <div class="text-right pr-4">
              {{date}}
            </div>
          </b-col>
        </b-row>
        <b-collapse :visible="showMessage" @shown="onContentShown">
          <div class="message-item-content mr-3 mt-3" v-html="content" />
        </b-collapse>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import moment from 'moment'
import MessageType from '@/components/common/MessageType'
import Avatar from '@/components/common/Avatar'
import { userName, linebreaks, stripeHTML } from '@/helpers/helpers'

export default {
  name: 'MessageItem',

  props: {
    type: {
      type: String
    },

    message: {
      type: Object,
      required: true
    }
  },

  computed: {
    date() {
      return moment(this.message.createdAt).fromNow()
    },

    preview() {
      const content = stripeHTML(this.message.content)
      return content.length > 50 ? content.substr(0, 50) + '...' : content
    },

    content() {
      return linebreaks(this.message.content)
    }
  },

  data() {
    return {
      showMessage: false
    }
  },

  methods: {
    userName(profile) {
      return profile.type === 'user' ? userName(profile) : ''
    },

    onContentShown() {
      if (this.type === 'received' && !this.message.seenAt) {
        this.$emit('seen', this.message)
      }
    }
  },

  components: {
    Avatar,
    MessageType
  }
}
</script>
